// extracted by mini-css-extract-plugin
export default {"DonutContainer":"DonutChart_DonutContainer__YojzT","Donut":"DonutChart_Donut__SFxRb"};